import { render, staticRenderFns } from "./BeneficioAtivo.vue?vue&type=template&id=a0cfa580&scoped=true&"
import script from "./BeneficioAtivo.vue?vue&type=script&lang=js&"
export * from "./BeneficioAtivo.vue?vue&type=script&lang=js&"
import style0 from "./BeneficioAtivo.vue?vue&type=style&index=0&id=a0cfa580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cfa580",
  null
  
)

export default component.exports